import { useAppDispatch, useAppSelector } from "app/hooks";
import FeatureToggle from "enums/FeatureToggle";
import FormType from "enums/FormType";
import { selectFeatureToggle } from "features/featureToggles/featureToggleSlice";
import { Assessment } from "features/scorable/Assessment";
import { loadScorable } from "features/scorable/scorableSlice";
import { useCallback, useEffect } from "react";
import { useParams } from "react-router-dom";
import embeddingService from "services/embeddingService";
import windowEventService from "services/windowEventService";

export function AssessmentRoute() {
    const { assignmentId } = useParams();

    const isAssessmentUIEnhancementsFeatureEnabled = useAppSelector((state) => {
        return (
            selectFeatureToggle(
                state,
                FeatureToggle.ASSESSMENT_UI_ENHANCEMENTS_TOGGLE
            ) && selectFeatureToggle(state, FeatureToggle.LEARNING_SCORM)
        );
    });

    const dispatch = useAppDispatch();

    const onAssessmentDataReceived = useCallback(
        (event: MessageEvent) => {
            const messageData = event.data;
            if (
                event.source === window.parent &&
                messageData.type == "set-assessment-data"
            ) {
                dispatch(
                    loadScorable({
                        formType: FormType.ASSESSMENT,
                        assignmentData: messageData.assignmentData,
                    })
                ).then((e) => {
                    if ("error" in e) {
                        embeddingService.notifyErrors(
                            "assessment-loading-failed"
                        );
                    } else {
                        embeddingService.sendFormLoadedStatus(true);
                    }
                });
            }
        },
        [dispatch]
    );
    useEffect(() => {
        if (isAssessmentUIEnhancementsFeatureEnabled) {
            windowEventService.registerEvent(
                "assessment-form-data-received-event-listener",
                "message",
                onAssessmentDataReceived
            );

            embeddingService.sendFormReadyStatus(true);

            return () => {
                windowEventService.removeEvent(
                    "assessment-form-data-received-event-listener",
                    "message"
                );
            };
        } else if (assignmentId) {
            dispatch(
                loadScorable({
                    formType: FormType.ASSESSMENT,
                    assignmentId,
                })
            ).then((e) => {
                if ("error" in e) {
                    embeddingService.notifyErrors("assessment-loading-failed");
                } else {
                    embeddingService.sendFormLoadedStatus(true);
                }
            });
        }
    }, [
        dispatch,
        assignmentId,
        onAssessmentDataReceived,
        isAssessmentUIEnhancementsFeatureEnabled,
    ]);

    return <Assessment />;
}
